import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HtmlEditorComponent } from 'src/app/controls/components/advanced/html-editor/html-editor.component';
import { MacroDefinition } from 'src/app/mail-templates/models/macro-definition';

@Component({
    selector: 'app-mail-template-edit',
    templateUrl: './mail-template-edit.component.html',
    styleUrls: ['./mail-template-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, HtmlEditorComponent]
})
export class MailTemplateEditComponent implements OnInit, OnChanges {
    @Input() subject = '';
    @Input() body = '';
    @Input() macros: MacroDefinition[] = [];
    @Input() enabled = true;
    @Input() extendedToolbar = false;
    @Output() subjectChange = new EventEmitter<string>();
    @Output() bodyChange = new EventEmitter<string>();

    readonly formGroup = this.fb.group({
        subject: [this.subject, Validators.required],
        body: [this.body, Validators.required]
    });

    constructor(
        private fb: FormBuilder,
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.subject) {
            this.formGroup.patchValue({ subject: this.subject });
        }
        if (changes.body) {
            this.formGroup.patchValue({ body: this.body });
        }
        if(changes.macros)
        {
            this.macros = this.macros.sort((a, b) => a.Macro.localeCompare(b.Macro));
        }
        if(changes.enabled)
        {
            if(this.enabled)
            {
                this.formGroup.enable();
            }
            else
            {
                this.formGroup.disable();
            }
        }
    }

    ngOnInit(): void {
        this.formGroup.controls.subject.valueChanges.subscribe(newValue => this.subjectChange.emit(newValue));
        this.formGroup.controls.body.valueChanges.subscribe(newValue => this.bodyChange.emit(newValue));
    }

    showError(path: string, errorCode?: string): boolean {
        const fc = this.formGroup.get(path) as FormControl;
        return errorCode ? fc.hasError(errorCode) : fc.invalid;
    }
}
